import RestAPI from '../../Common/restApi';

export default class RequestApi {
  static index(customerId, page, perPage, filterParams) {
    return RestAPI.getWithFormData(`/api/v2/pro/customers/${customerId}/requests`, {
      page: page,
      limit: perPage,
      ...filterParams,
    });
  }

  static fetchInvoiceBody(requestIds, jobUuids) {
    return RestAPI.getWithFormData('/api/v2/pro/requests/invoice_body', {
      request_ids: requestIds,
      job_uuids: jobUuids,
    });
  }

  static fetchInvoiceAttachments(requestIds, jobUuids) {
    return RestAPI.getWithFormData('/api/v2/pro/requests/invoice_attachments', {
      request_ids: requestIds,
      job_uuids: jobUuids,
    });
  }

  static emailJobInvoice(params) {
    return RestAPI.postWithFormData('/api/v2/pro/requests/email_job_invoice', params);
  }

  static emailEstimate(params) {
    return RestAPI.postWithFormData('/api/v2/pro/requests/email_estimate', params);
  }

  static textInvoiceOrEstimate(params) {
    return RestAPI.postWithFormData('/api/v2/pro/requests/text_invoice_or_estimate', params);
  }
}
